/**
 * SEO Constants
 * Author profiles, statistics, and key metrics for SEO optimization
 */

export const AUTHORS = {
  'Samuel Su': {
    '@type': 'Person',
    name: 'Samuel Su',
    jobTitle: 'Founder & CEO',
    url: 'https://medical.chat-data.com/team',
    image: '/images/samuel_su.jpeg',
    description:
      'Medical AI expert specializing in diagnostic AI and HIPAA-compliant healthcare solutions.',
    knowsAbout: [
      'Medical Artificial Intelligence',
      'HIPAA Compliance',
      'Healthcare Diagnostics',
      'USMLE AI Benchmarks',
      'Clinical Decision Support',
      'Medical Chatbots',
      'AI Safety in Healthcare',
    ],
    sameAs: [
      'https://twitter.com/truechatdata',
      'https://www.linkedin.com/company/chat-data',
    ],
  },
  // Add more authors as needed
};

export const STATISTICS = {
  usmlAccuracy: {
    value: '98.1%',
    label: 'USMLE Accuracy',
    source: 'Medical Chat USMLE Performance Evaluation',
    url: 'https://medical.chat-data.com/evaluate',
    date: '2024-01-15',
  },
  medqaAccuracy: {
    value: '97.8%',
    label: 'MedQA Accuracy',
    source: 'Medical Chat MedQA Benchmark',
    url: 'https://medical.chat-data.com/evaluate',
    date: '2024-01-15',
  },
  ranking: {
    value: '#1',
    label: 'Official Leaderboard Ranking',
    description: 'Surpassing Google Med-PaLM 2 and OpenAI GPT-4',
    url: 'https://medical.chat-data.com/evaluate',
  },
};

export const ORGANIZATION = {
  '@type': 'MedicalBusiness',
  name: 'Medical Chat',
  alternateName: 'Medical Chat - AI Healthcare Assistant',
  url: 'https://medical.chat-data.com',
  logo: 'https://medical.chat-data.com/logo.png',
  description:
    'Trusted AI medical assistant with 98.1% USMLE accuracy. HIPAA-compliant healthcare diagnosis and clinical decision support.',
  foundingDate: '2023',
  knowsAbout: [
    'Medical Diagnosis',
    'Symptom Analysis',
    'HIPAA Compliance',
    'Clinical Decision Support',
    'Medical AI',
    'Healthcare Technology',
    'USMLE Standards',
  ],
  medicalSpecialty: [
    'General Practice',
    'Internal Medicine',
    'Emergency Medicine',
    'Pediatrics',
  ],
  sameAs: [
    'https://twitter.com/truechatdata',
    'https://www.linkedin.com/company/chat-data',
  ],
};

export const BASE_URL = 'https://medical.chat-data.com';
